import React from 'react';

import List from '@material-ui/core/List';

import Stop from './Stop';
import SparkStop from './SparkStop';

import styles from './Stops.module.scss';

import { moveAndPushDown } from '../../common/collection';
import { getStopType } from '../../common/routes';
import { isEmpty, cloneDeep } from 'lodash';

export default class Stops extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      highlight: -1,
    };
    
    this.onSwapComplete = this.onSwapComplete.bind(this);
  }

  onSwapComplete(from, to) {
    const fromInt = parseInt(from.toString());
    const toInt = parseInt(to.toString());
    if (fromInt >= 0 && toInt >= 0 && fromInt !== toInt) {
        const stops = moveAndPushDown(this.props.stops, fromInt, toInt);
        this.props.onSwapStopsFunc(stops);
        
    }
    this.setState({ highlight: -1, });
  }

  highlightDestination = (stopNumber) => {
    this.setState({
      highlight: stopNumber,
    });
  };  

  renderStops(stops) {
    this.props.handleCorruptStops(false);
    if (isEmpty(stops)) return <div />;
    const { highlight = -1 } = cloneDeep(this.state);

    let stopNumber = 0;
    let stepIndex = 1;
    try {
      return stops.map(s => {
        ++stopNumber;
        let index = stopNumber - 1;
        s.index = index;
        if (s.type === getStopType().SPARK_STOP) {
          return (         
          <SparkStop key={`stop-${index}`}
              index={index}
              stepIndex={s.type !== 'payment-only' ? stepIndex++ : -1}
              stop={cloneDeep(s)}
              onSelectStopFunc={this.props.onSelectStopFunc}
              onSwapFunc={this.onSwapComplete}
              highlight={highlight}
              highlightDestinationFunc={this.highlightDestination}
              />);
          
        } else {
          return (          
            <Stop
                key={`stop-${index}`}
                index={index}
                stepIndex={s.type !== 'payment-only' ? stepIndex++ : -1}
                isNotActive={this.props.notActiveItems.includes(s?.item?.id)}
                stop={cloneDeep(s)}
                onUpdateBookingItemPaymentFunc={this.props.onUpdateBookingItemPaymentFunc}
                onUpdateBookingItemActivityFunc={this.props.onUpdateBookingItemActivityFunc}
                onUpdateStopBookingNoteFunc={this.props.onUpdateStopBookingNoteFunc}
                onUpdateBookingItemPriceFunc={this.props.onUpdateBookingItemPriceFunc}
                onSelectStopFunc={this.props.onSelectStopFunc}
                stopNumber={stopNumber}
                onSwapCompleteFunc={(from, to) => this.onSwapComplete(from, to)}
                highlight={this.state.highlight}
                highlightDestinationFunc={this.highlightDestination}
                bookingId={this.props.bookingId}
                occasionBookingId={this.props.occasionBookingId}
              />
          );
        }
      });
    } catch(err) {
      this.props.handleCorruptStops(true);
    }
  }

  render() {
    const stops = this.props.stops || [];

    return <List className={styles.fullWidthColumn}>{this.renderStops(stops)}</List>;
  }
}
